import * as React from 'react';
import styled from 'styled-components';
import { getUpdatedPinCodeWithValue } from './PinCodeInput.logic';
import { IPinCodeInputProps } from './PinCodeInput.types';

const PinCodeWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const PinInput = styled.input<{ invalid: boolean }>`
  width: 40px !important;
  height: 48px;
  border: 1px solid ${({ theme }) => theme.colors.elevation1};
  border-radius: 4px;
  padding: 0 17px;
  ${({ invalid, theme }) =>
    invalid &&
    `
      border-color: ${theme.colors.alert}
    `};
`;

const PinCodeInput = (props: IPinCodeInputProps) => {
  const { pinLength = 5, onChange, invalid, testId } = props;
  const [pinCode, setPinCode] = React.useState(
    Array.from(Array(pinLength).keys()).map(() => ({
      value: null
    }))
  );
  const pinCodeRef = React.useRef(null);

  React.useEffect(() => {
    const resultPinCode = pinCode.map(pinNumber => pinNumber.value).join('');

    if (onChange && resultPinCode.length === pinLength) {
      onChange(resultPinCode);
    }
  }, [pinCode]);

  return (
    <PinCodeWrapper ref={pinCodeRef} data-testid={testId || 'pin-code-wrapper'}>
      {pinCode.map((pinNumber, index) => (
        <PinInput
          className="pin-number-input"
          id="pin-number-input"
          invalid={invalid}
          type="password"
          // eslint-disable-next-line react/no-array-index-key
          key={`pin-code-input-${index}`}
          autoComplete="off"
          maxLength={1}
          value={pinNumber.value}
          onKeyDown={event => {
            const removeButtons = ['Backspace', 'Delete'];
            const pressedValue = event.key;

            if (removeButtons.includes(pressedValue)) {
              const newPinCode = getUpdatedPinCodeWithValue(
                pinCode,
                index,
                null
              );
              setPinCode(newPinCode);
            }
          }}
          onKeyPress={event => {
            const pressedValue = event.key;
            const currentCodeNumberNode = event.currentTarget;
            const nextNumberInputNode = pinCodeRef.current.querySelectorAll(
              '.pin-number-input'
            )[index + 1];

            if (!/^\d+$/.test(pressedValue)) {
              return;
            }

            const numericValue = Number.parseInt(event.key, 10);
            const newPinCode = getUpdatedPinCodeWithValue(
              pinCode,
              index,
              numericValue
            );

            setPinCode(newPinCode);
            if (nextNumberInputNode) {
              nextNumberInputNode.focus();
            } else {
              currentCodeNumberNode.blur();
            }
          }}
        />
      ))}
    </PinCodeWrapper>
  );
};

export default PinCodeInput;
